/**
 * Project branding configuration.
 *
 * Set REACT_APP_PROJECT to one of: M4D, ENSEMBLE, CIRCAT, XTRUST
 * Each project defines its own palette, logo and page title.
 */

import getEnv from "../config";

const PROJECT = getEnv("REACT_APP_PROJECT", "M4D").toUpperCase();

const projects = {
  M4D: {
    name: "M4D",
    logo: "/assets/M4D.png",
    title: "M4D",
    palette: {
      mode: "dark",
      primary: { main: "#546e7a" },
      secondary: { main: "#26a69a" },
      error: { main: "#FF0000" },
      background: { default: "#121212", paper: "#242424" },
      text: { primary: "#ffffff", secondary: "#cfd8dc" },
    },
    chartColors: ["#4b8085", "#6b8a89", "#86a3a5", "#a5bdbf", "#cfdfe0", "#66bb6a", "#ef5350", "#ffa726"],
  },

  ENSEMBLE: {
    name: "ENSEMBLE",
    logo: "/assets/ensemble-logo-light.png",
    title: "ENSEMBLE",
    palette: {
      mode: "dark",
      primary: { main: "#063f5b" },
      secondary: { main: "#f37e0f" },
      error: { main: "#FF0000" },
      background: { default: "#0a1c24", paper: "#0f2a35" },
      text: { primary: "#ffffff", secondary: "#8efafe" },
    },
    chartColors: ["#f37e0f", "#f5993f", "#063f5b", "#0d6d94", "#8efafe", "#66bb6a", "#ef5350", "#ffa726"],
  },

  CIRCAT: {
    name: "CIRCAT",
    logo: "/assets/circat-logo.png",
    title: "CIRCAT",
    palette: {
      mode: "dark",
      primary: { main: "#0064AD" },
      secondary: { main: "#0078D2" },
      error: { main: "#FF0000" },
      background: { default: "#0a1520", paper: "#0f2030" },
      text: { primary: "#ffffff", secondary: "#b0cfe0" },
    },
    chartColors: ["#0064AD", "#0078D2", "#3a9ae0", "#6bb8ec", "#b0cfe0", "#66bb6a", "#ef5350", "#ffa726"],
  },

  XTRUST: {
    name: "XTRUST",
    logo: "/assets/xtrust-logo.png",
    title: "XTRUST",
    palette: {
      mode: "dark",
      primary: { main: "#64307E" },
      secondary: { main: "#C69EDA" },
      error: { main: "#FF0000" },
      background: { default: "#120a18", paper: "#1e1228" },
      text: { primary: "#ffffff", secondary: "#B6AEC6" },
    },
    chartColors: ["#64307E", "#8B4DAB", "#C69EDA", "#d4b5e5", "#B6AEC6", "#66bb6a", "#ef5350", "#ffa726"],
  },
};

const branding = projects[PROJECT] || projects.M4D;

export default branding;
export { PROJECT, projects };
